<ng-container *ngIf="!cardDeleteLoading">
  <div class="flex justify-center items-center w-full h-full flex-col" [ngStyle]="{'background-color': sessionData.sessionDisplayInformation.colorScheme.slice(0, sessionData.sessionDisplayInformation.colorScheme.length-1)}">
    <!-- [ngStyle]="{'background-color': sessionData.sessionDisplayInformation.colorScheme.slice(0, sessionData.sessionDisplayInformation.colorScheme.length-1)}" -->
    <!-- [ngStyle]="{'border': '3px solid ' + sessionData.sessionDisplayInformation.colorScheme.slice(0, sessionData.sessionDisplayInformation.colorScheme.length-1)}" -->
    <div class="ml-4 mr-4 mt-6 text-xl text-center">
      <p class="text-white">Are you sure you want to delete this card?</p>
    </div>
    <div class="flex justify-center mb-2 w-full">
      <button mat-button mat-raised-button class="w-1/3" style="color: white; background-color: #41a3c3;" (click)="performAction(false)">Cancel</button>
      <button mat-button mat-raised-button class="ml-2 w-1/3" color="warn" style="color: white;" (click)="performAction(true)">Yes</button>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="cardDeleteLoading">
  <div *ngIf="cardDeleteLoading" class="flex justify-center items-center" style="height: 85px;" [ngStyle]="{'background-color': sessionData.sessionDisplayInformation.colorScheme.slice(0, sessionData.sessionDisplayInformation.colorScheme.length-1)}">
    <mat-spinner
      class="loading-spinner"
      color="accent"
      diameter="50"
    ></mat-spinner>
  </div>
</ng-container>



